import { configs } from '../../config';
import { DepositOptions } from '../constants';
/**
 * @typedef {import('@securitize/reactjs-mfe').FrInvestmentMicroFrontendParams["opportunity"]} OpportunityDetails
 */

export const buildUserInfo = (user, config) => ({
  countryCode: user.countryCode,
  email: user.investorEmail,
  fullName: user.investorFullName,
  entityName: user.entityName,
  investorId: user.investorId,
  verificationStatus: user.verificationStatus,
  sidVerificationStatus: user.sidVerificationStatus,
  accreditationStatus: user.accreditationStatus,
  suitabilityStatus: user.suitabilityStatus,
  accountStatus: user.bdAccountStatus,
  brokerDealerId: user.brokerDealerId,
  language: config.issuerLanguage,
  investorType: user.investorType,
});

export const buildOpportunity = (opportunityDetails, config) => (
/**
* @type { OpportunityDetails }
*/
  {
    id: opportunityDetails.id,
    issuerId: config.issuerId,
    issuerName: config.issuerName,
    issuerIcon: config.favicon,
    tokenDecimals: opportunityDetails.tokenDecimals,
    tokenIcon: opportunityDetails.tokenIcon,
    isTokenCalculatorVisible: opportunityDetails.isTokenCalculatorVisible,
    tokenName: opportunityDetails.tokenName,
    tokenSymbol: opportunityDetails.tokenSymbol,
    currencies: opportunityDetails.currencies,
    depositOptions: configs.ENABLE_CASH_ACCOUNT
      ? opportunityDetails.depositOptions
      : opportunityDetails.depositOptions?.filter(
        (option) => option !== DepositOptions.CASH_ACCOUNT,
      ),
    type: opportunityDetails.type,
    isBrokerDealer: opportunityDetails.isBrokerDealer,
  });
